<div
  *ngFor="let row of components$ | async; trackBy: trackByComponentGuid"
  [id]="row.anchor ? row.anchor.substring(1) : null"
  [name]="row.anchor ? row.anchor.substring(1) : null"
>
  <ng-container elmEditorRow [type]="row.type" [rowId]="row.pageGuid"></ng-container>
</div>

<ng-template #headerTmpl> <elm-app-application-header></elm-app-application-header> </ng-template>

<ng-template #panelTmpl let-row> <elm-app-applications-panel [row]="row"></elm-app-applications-panel> </ng-template>
